import { render, staticRenderFns } from "./freeShooting.vue?vue&type=template&id=120c092e&scoped=true"
import script from "./freeShooting.vue?vue&type=script&lang=js"
export * from "./freeShooting.vue?vue&type=script&lang=js"
import style0 from "./freeShooting.vue?vue&type=style&index=0&id=120c092e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c092e",
  null
  
)

export default component.exports